export default "__VITE_ASSET__CQtkaHiu__"